import { SafePaddingContainer } from "@/components/SafePaddingContainer"
import { SecondaryHeader } from "@/components/SecondaryHeader"
import { Button } from "@/components/ui/button"
import { InitiateWithdrawalSection } from "@/components/InitiateWithdrawalSection"
// import { useNavigate } from "react-router-dom"
import { useModal } from "@/hooks/useModal"
// import { PurchaseModal } from "@/components/Modals/PurchaseModal"
// import { storeListings } from "@/helpers/storeListings"
// import type { GameThemeId } from "@skillscratch/shared-types"
import { useBalance } from "@/hooks/useBalance"
import { centsToPrettyDollars } from "@skillscratch/shared-util"
import { useEffect } from "react"
import { ErrorModal } from "@/components/Modals/ErrorModal"
import { AllCardsModal } from "@/components/Modals/AllCardsModal"
import { Gift } from 'lucide-react'
import { useMemo } from "react"


// import paydayBonanze




export function WalletPage() {
    // const navigate = useNavigate();
    const { openModal } = useModal();
    // const paydayBonanza = storeListings[0];
    const [userData, isUserDataLoading, userBalanceError] = useBalance();

    
    const winMoreClick = () => {
       openModal(<AllCardsModal />);
    };

    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        if (userBalanceError) {
            openModal(<ErrorModal message={userBalanceError.message}/>);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userBalanceError]);

      const stringifiedBalance = useMemo(() => {
          return userData?.balance !== undefined ? centsToPrettyDollars(userData?.balance) : "$0.00";
      }, [userData?.balance]);
    
      const stringifiedPromoBalance = useMemo(() => {
          return userData?.promoBalance !== undefined ? centsToPrettyDollars(userData?.promoBalance) : "$0.00";
      }, [userData?.promoBalance])

    return (
        <div className="flex flex-col h-screen overflow-y-scroll pb-40 bg-white">
            <SafePaddingContainer orientation='header' className='bg-blue'>
                <SecondaryHeader text={'Wallet'} />
                {/* Main content */}
            </SafePaddingContainer>
            <SafePaddingContainer orientation='footer' className='bg-white'>
                <div className="p-4 max-w-md mx-auto mt-6">

                    <div className="flex items-center justify-between mb-8">
                        <div>
                            {
                                isUserDataLoading ? (
                                    <div className="flex items-center h-7">
                                        <div className="h-5 w-24 bg-gray-200 animate-pulse rounded" />
                                    </div>
                                ) : userBalanceError ? (
                                    <p className="text-red-500 text-lg">Failed to load balance</p>
                                ) : (
                                    <>
                                        <h1 className="text-2xl font-semibold text-blue-dark tracking-tight">
                                            <p className="text-blue-dark">{stringifiedBalance}</p>
                                        </h1>
                                        {
                                            (userData?.promoBalance ?? 0) > 0 ? (
                                                <span className='flex flex-row items-center gap-0.5 text-blue-dark font-medium text-sm opacity-80'>
                                                    <Gift size={16} />
                                                    <span>{stringifiedPromoBalance}</span>
                                                </span>
                                            ) : null
                                        }
                                    </>
                                )
                            }
                        </div>
                        <Button shine variant='wallet-btn' size='walletBtn' className="bg-blue text-white"
                        onClick={() => winMoreClick()}>
                            Win more
                        </Button>
                    </div>

                    {/* <div className='mb-8'>
                        <h2 className="text-2xl font-bold text-blue-dark mb-1">Payment method</h2>
                        <p className="text-blue-dark mb-6 text-sm">
                            Your most recent successful card purchase will determine your default card
                        </p>
                        <PaymentsList />
                    </div> */}

                    <div className='mb-8'>
                        <h2 className="text-2xl font-bold text-blue-dark mb-1">Keep winning big</h2>
                        <p className="text-blue-dark mb-6 text-sm">
                            Let's keep winning. Tap below to buy cards to keep scratching and winning.
                        </p>
                        <Button 
                            className={'py-6 bg-blue text-white text-2xl font-bold w-full rounded-lg}'}
                            shine
                            onClick={() => winMoreClick()}
                        >
                            Win more now
                        </Button>
                    </div>
                <InitiateWithdrawalSection />
                </div>
            </SafePaddingContainer>
        </div>
    )
}